import initialize_vue_app from "./initialize_vue_app";
import FrontendApplication from "../frontend";

// Will be loaded in pack file
window.initialize_vue = (selector) => {
  initialize_vue_app(FrontendApplication, selector)
};
